import { GetFeatureFlags } from '@/connection/feature-flags';
import { store } from '@/store/main';
import { setFeatureFlags } from '@/store/slices/feature-flags';
import blAuth from '@/connection/bl-auth/bl-auth';
import { setAuthTokens } from '@/store/slices/user';
import { loadChannels } from '@/store/slices/channels';

let authReadyResolver: (() => void) | null = null;

export const authReady = new Promise<void>((resolve) => {
  authReadyResolver = resolve;
});

export const mainLoader = async (): Promise<Response> => {
  try {
    const loadFeatureFlags = async () => {
      const featureFlags = await GetFeatureFlags();
      store.dispatch(setFeatureFlags(featureFlags));
    };

    const auth = async () => {
      await blAuth.handleRedirected();
      const url = new URL(window.location.href);
      let theme = undefined;

      if (url.pathname.startsWith('/webinarplus')) {
        theme = 'webinarplus';
      }
      if (blAuth.refreshToken) {
        await blAuth.refresh();
        blAuth.initializeActivityTracker({ refreshOnInterval: true });
      } else {
        blAuth.redirectToSignIn({ redirect_uri: window.location.href, theme });
      }
      store.dispatch(
        setAuthTokens({
          idToken: blAuth.idToken as string,
          refreshToken: blAuth.refreshToken as string,
        })
      );
      store.dispatch(loadChannels({ useCache: true }));
      authReadyResolver?.();
    };

    await Promise.all([loadFeatureFlags(), auth()]);
    return new Response(null, { status: 200 });
  } catch (error) {
    console.error(error);
    authReadyResolver?.();
    return new Response(null, { status: 500 });
  }
};
